import React from "react";
import { OutletContext, useOutlet } from "./Router";

export default function Outlet() {
    const components = useOutlet();

    if (components.length === 0) {
        return null;
    }

    return (
        <OutletContext.Provider value={components.slice(1)}>
            {components[0]}
        </OutletContext.Provider>
    );
}
